// iter86.90 — ESPN retirement: this tab (historically "EspnSyncTab") is
// now the Data Feed tab hosting API-Football / GotSport / CSV cards +
// the tournament-window dates card. All ESPN config/preview/sync UI was
// removed (feed retired — WC over, operator decision). Legacy ESPN
// tournaments keep rendering read-only; their sync endpoints survive
// server-side for emergency use only (game_health_registry #7).
import GotSportImportCard from "@/components/GotSportImportCard";
import ApiFootballImportCard from "@/components/ApiFootballImportCard";
import TournamentDatesCard from "./TournamentDatesCard";
import CsvUploadCard from "./CsvUploadCard";

export default function EspnSyncTab({ tournament, league, leagueId, isLocked, isCustom, onChanged }) {
    // iter84.9 — For CUSTOM tournaments, scope each card to the
    // `tournament.data_source` chosen during the wizard.
    const tds = tournament?.data_source;
    const isLegacyCustom = isCustom && !tds; // pre-iter83.5 — no data_source
    const customCardAllowed = (feedKey) => {
        if (!isCustom) return true;        // templates always render their cards
        if (isLegacyCustom) return true;   // legacy custom: back-compat, show entitled cards
        return tds === feedKey;            // post-wizard: only matching feed
    };

    return (
        <div className="space-y-5">
            {/* iter63b — API-Football (api-sports.io) import. Gated by the
                site-admin per-league `api_football_enabled` flag. */}
            {league?.api_football_enabled && (!isCustom || isLegacyCustom) && (
                <div className="brutal-card p-5">
                    <ApiFootballImportCard
                        leagueId={leagueId}
                        tournament={tournament}
                        onImported={onChanged}
                    />
                </div>
            )}
            {/* iter47e — GotSport in its own banner, entitlement-gated. */}
            {isCustom && league?.gotsport_enabled && customCardAllowed("gotsport") && (
                <div className="brutal-card p-5">
                    <GotSportImportCard
                        leagueId={leagueId}
                        tournament={tournament}
                        onImported={onChanged}
                    />
                </div>
            )}
            {/* iter84.4 — CSV upload card, entitlement + data_source gated. */}
            {isCustom && league?.feed_csv_enabled && customCardAllowed("csv") && (
                <CsvUploadCard
                    tournament={tournament}
                    isLocked={isLocked}
                    onChanged={onChanged}
                />
            )}
            {/* Tournament window — admins still need the dates card for
                non-ESPN syncs (GotSport window, display). */}
            {isCustom && (
                <div className="brutal-card p-5">
                    <TournamentDatesCard
                        tournament={tournament}
                        isLocked={isLocked}
                        onSaved={onChanged}
                    />
                </div>
            )}
        </div>
    );
}
